import classNames from "classnames";
import React from "react";

const RoundIcon = ({
  icon: Icon,
  iconColorClass = "text-purple-600",
  bgColorClass = "bg-purple-100",
  className,
  onClick
}) => {
  const baseStyle = "p-3 rounded-md cursor-pointer";

  const cls = classNames(baseStyle, iconColorClass, bgColorClass, className);
  return (
    <div className={cls} onClick={onClick}>
      <Icon className="w-8 h-8" />
    </div>
  );
};

export default RoundIcon;
